import React from 'react';
import { PortalWithState } from 'react-portal';
import CancelModal from './CancelModal';
import AssignModal from './AssignModal';
import BulkSurveyStatusModal from './BulkSurveyStatusModal';
import useMode from '../../../../hooks/useMode';
import Button from '../../../../components/Button/Button';

type JobsActionsProps = { assignmentIds: string[] | readonly string[] };

const JobsActions: React.FC<JobsActionsProps> = ({
  assignmentIds,
}): JSX.Element => {
  const mode = useMode();
  if (mode === 'individual') {
    return <></>;
  }
  return (
    <>
      <PortalWithState closeOnOutsideClick closeOnEsc>
        {({ openPortal, closePortal, portal }) => (
          <>
            <Button
              variant="outline"
              disabled={!assignmentIds.length}
              icon="edit"
              onClick={openPortal}
            >
              Set Status
            </Button>
            {portal(
              <BulkSurveyStatusModal
                jobIds={assignmentIds}
                onClose={closePortal}
              />
            )}
          </>
        )}
      </PortalWithState>
      <PortalWithState closeOnOutsideClick closeOnEsc>
        {({ openPortal, closePortal, portal }) => (
          <>
            <Button
              variant="outline"
              disabled={!assignmentIds.length}
              icon="slash-circle"
              onClick={openPortal}
            >
              Cancel
            </Button>
            {portal(
              <CancelModal
                action="CANCEL"
                assignmentIds={assignmentIds}
                onClose={closePortal}
              />
            )}
          </>
        )}
      </PortalWithState>
      <PortalWithState closeOnOutsideClick closeOnEsc>
        {({ openPortal, closePortal, portal }) => (
          <>
            <Button
              variant="outline"
              disabled={!assignmentIds.length}
              icon="person"
              onClick={openPortal}
            >
              Assign
            </Button>
            {portal(
              <AssignModal
                action="ASSIGN"
                assignmentIds={assignmentIds}
                onClose={closePortal}
              />
            )}
          </>
        )}
      </PortalWithState>
    </>
  );
};

export default JobsActions;
